import Item from './Item'
import Option from './Option'

export const ProductType = Object.freeze({
  SINGLE: 0,
  SET_THREE: 1,
  SET_FIVE: 2,
  SET_SEVEN: 3
})

export const ProductStateType = Object.freeze({
  PURCHASABLE: 'PURCHASABLE',
  DISABLED: 'DISABLED',
  SOLD_OUT: 'SOLD_OUT',
  NOT_FIRST_PURCHASE: 'NOT_FIRST_PURCHASE',
  NOT_FIRST_PURCHASE_GUEST: 'NOT_FIRST_PURCHASE_GUEST'
})

class Product {
  constructor(
    {
      productId,
      productName,
      productType,
      baeminShopNo,
      imageUrl,
      returnOrExchange,
      retailPrice = 0,
      salePrice = 0,
      quantity = 1,
      minCount = 1,
      maxCount = 1,
      items,
      options,
      checked = true,
      state = 'PURCHASABLE',
      firstPurchaseOnlyProduct = false
    },
    unpurchasable = false
  ) {
    this.id = productId
    this.name = productName
    this.type = Object.keys(ProductType).indexOf(productType)
    this.baeminShopNo = baeminShopNo
    this.returnOrExchange = returnOrExchange
    this.image = imageUrl
    this.minCount = minCount
    this.maxCount = maxCount
    this.unpurchasable = unpurchasable
    this.state = ProductStateType[state]
    this.firstPurchaseOnlyProduct = firstPurchaseOnlyProduct

    this.stockCount = items.reduce((iter, item) => {
      if (iter > item.stockCount) iter = item.stockCount
      return iter
    }, Infinity)

    this.retailPrice = retailPrice
    this.salePrice = salePrice
    this.quantity = quantity
    this.checked = this.stockCount < quantity ? false : checked
    this.locked = this.stockCount < quantity

    if (items) {
      this.items = items.map(item => {
        const newItem = new Item({ ...item, unpurchasable, firstPurchaseOnlyProduct: this.firstPurchaseOnlyProduct })
        return newItem
      })
    } else this.items = []

    if (options) {
      this.options = options.map(option => {
        const newOption = new Option({ ...option, nowCount: this.items[0].quantity })
        return newOption
      })
    } else this.options = []
    
  }

  select(state) {
    if (this.stockCount < this.quantity) return

    this.checked = state
  }

  selectItems(state) {
    this.items.forEach((item) => item.select(state))
  }

  addQuantity() {
    if (this.quantity >= this.maxCount) return

    this.quantity += 1
  }

  subQuantity() {
    if (this.quantity <= this.minCount) return

    this.quantity -= 1
  }

  getId() {
    return this.id
  }

  getMaxCount() {
    return this.maxCount
  }

  getMinCount() {
    return this.minCount
  }

  getProductId() {
    return this.productId
  }

  getType() {
    return this.type
  }

  getLocked() {
    return this.locked
  }

  getName() {
    return this.name
  }

  getQuantity() {
    return this.quantity
  }

  getSalePrice() {
    return this.salePrice
  }

  getStockCount() {
    return this.stockCount
  }

  getRetailPrice() {
    return this.retailPrice
  }

  getReturnOrExchange() {
    return this.returnOrExchange
  }

  getImage() {
    return this.image
  }

  getItems() {
    return this.items
  }

  getOptions() {
    return this.options.filter(option => option.getNowCount() > 0)
  }

  getBaeminShopNo() {
    return this.baeminShopNo
  }

  getChecked() {
    return this.checked
  }

  isPurchasable() {
    return this.state === ProductStateType.PURCHASABLE
  }

  isUnpurchasable() {
    return this.unpurchasable
  }

  getSoldOut() {
    return this.state === ProductStateType.SOLD_OUT
  }

  getDisabled() {
    return this.state === ProductStateType.DISABLED
  }

  getNotFirstPurchase() {
    return this.state === ProductStateType.NOT_FIRST_PURCHASE
  }

  getNotFirstPurchaseGuest() {
    return this.state === ProductStateType.NOT_FIRST_PURCHASE_GUEST
  }

  getFirstPurchaseOnlyProduct() {
    return this.firstPurchaseOnlyProduct
  }
}

export default Product
